import { pusherKey, pusherCluster, backendUrl } from '../app-globals';
import Pusher from 'pusher-js';
import Vue from 'vue';
import constants from '../constants';
import store from '../store/index';
import router from '../router';
import moment from 'moment';
const userData = store.getters.getUser;
const organization = store.getters.getSelectedOrganization;
var buttonValue;
var totalComments;

const pusher = new Pusher(pusherKey, {
  cluster: pusherCluster,
  wssPort: 443,
  enabledTransports: ['ws'],
  forceTLS: true,
  encrypted: true,
  auth: {
    headers: {
      Authorization: `Bearer ${userData.token}`,
    },
  },
  authEndpoint: `${backendUrl}/api/devices/broadcasting/auth`,
});

Vue.prototype.$pusher = pusher;

store.subscribe((mutation, state) => {
  if (mutation.type === 'jobs/setButtonValue') {
    buttonValue = state.jobs.buttonValue;
  }

  if (mutation.type === 'jobs/setAllCommentsTotal') {
    totalComments = state.jobs.commentsTotal;
  }
});

if (organization !== null && organization.external_id !== undefined) {
  // app user channel
  var appUserOrganizationChannel = pusher.subscribe(
    `${constants.SOCKET_APP_USER_CHANNEL}.${userData.app_user.external_id}.${constants.SOCKET_ORGANIZATION_CHANNEL}.${organization.organization.external_id}`,
  );

  // Autocheckout
  appUserOrganizationChannel.bind(
    `${constants.SOCKET_APP_USER_AUTO_CHECKOUT}`,
    (e) => {
      window.location.reload();
    },
  );

  // AppUserRole Update
  appUserOrganizationChannel.bind(
    `${constants.SOCKET_APP_USER_ROLE_UPDATE}`,
    (e) => {
      const data = localStorage.getItem('selectedOrganization');
      const parsedData = JSON.parse(data);
      if (data) {
        store.dispatch('userprofile/fetchUserDetails').then(() => {
          const userDetails = store.getters['userprofile/getUserDetails'];
          const newAppUserRole =
            userDetails.selected_organization.app_user_role;
          const deviceAppUserRole = parsedData.app_user_role;
          if (newAppUserRole !== deviceAppUserRole) {
            localStorage.setItem(
              'selectedOrganization',
              JSON.stringify(userDetails.selected_organization),
            );
            window.location.reload();
          }
        });
      }
    },
  );

  // site manager channel
  if (organization.app_user_role === 'site-manager') {
    var siteManagerChannel = pusher.subscribe(
      `${constants.SOCKET_SITE_MANAGER_CHANNEL}.${organization.organization.external_id}`,
    );
    siteManagerChannel.bind(`${constants.SOCKET_JOB_INVOICE_CREATED}`, (e) => {
      store.dispatch('invoice/clearOutstandingInvoices');
      store.dispatch('invoice/fetchOutstandingInvoices', {
        orgExtId: organization.organization.external_id,
        params: {
          params: {
            status: ['pending', 'rejected', 'unpaid', 'approved'],
            startPage: 0,
            limit: 5,
          },
        },
      });
    });
  }
}

// Job channel
router.afterEach((to) => {
  if (to.path.includes('/comments')) {
    const jobId = window.location.pathname.split('/')[2];
    var jobCommetChannel = pusher.subscribe(
      `${constants.SOCKET_JOB_CHANNEL}.${jobId}.${constants.SOCKET_ORGANIZATION_CHANNEL}.${organization.organization.external_id}`,
    );
    jobCommetChannel.bind(`${constants.SOCKET_JOB_COMMENT_CREATED}`, (e) => {
      store.dispatch('jobs/jobCommentEventOccured', true);
      store.dispatch('jobs/fetchAllComments', {
        jobId: jobId,
        params: {
          params: {
            startPage: 0,
            limit: buttonValue ? 5 : totalComments + 1,
          },
        },
      });
    });
  }
});

// Device org channel
if (organization !== null && organization.external_id !== undefined) {
  var deviceOrganizationChannel = pusher.subscribe(
    `${constants.SOCKET_DEVICE_ORGANIZATION_CHANNEL}.${organization.organization.external_id}`,
  );

  // Timesheet status updated
  deviceOrganizationChannel.bind(
    `${constants.SOCKET_TIMESHEETS_STATUS_UPDATED}`,
    (e) => {
      // store.dispatch('timesheets/clearStoredPendingData');
      // store.dispatch('timesheets/fetchPendingTimesheets', {
      //   orgExtId: organization.organization.external_id,
      //   params: {
      //     params: {
      //       limit: 5,
      //       startPage: 0,
      //       status: ["pending", "declined"],
      //     },
      //   },
      // });
    },
  );
  // Timesheet update
  deviceOrganizationChannel.bind(
    `${constants.SOCKET_TIMESHEETS_UPDATE}`,
    (e) => {
      // store.dispatch('timesheets/clearStoredPendingData');
      // store.dispatch('timesheets/fetchPendingTimesheets', {
      //   orgExtId: organization.organization.external_id,
      //   params: {
      //     params: {
      //       limit: 5,
      //       startPage: 0,
      //       status: ["pending", "declined"],
      //     },
      //   },
      // });
    },
  );

  // Timesheet delete
  deviceOrganizationChannel.bind(
    `${constants.SOCKET_TIMESHEETS_DELETE}`,
    (e) => {
      // store.dispatch('timesheets/clearStoredPendingData');
      // store.dispatch('timesheets/fetchPendingTimesheets', {
      //   orgExtId: organization.organization.external_id,
      //   params: {
      //     params: {
      //       limit: 5,
      //       startPage: 0,
      //       status: ["pending", "declined"],
      //     },
      //   },
      // });
    },
  );

  // Attendance
  deviceOrganizationChannel.bind(
    `${constants.SOCKET_CHECKIN_SUCCESSFUL}`,
    (e) => {
      if (organization.app_user_role === 'worker') return;
      const date = moment().format('YYYY-MM-DD');
      const from = moment(`${date} 00:00:00`, 'YYYY-MM-DD HH:mm:ss')
        .utc()
        .format();
      const to = moment(`${date} 23:59:59`, 'YYYY-MM-DD HH:mm:ss')
        .utc()
        .format();
      store.dispatch('appusers/refreshAttendance', {
        params: {
          params: {
            from,
            to,
            startPage: 0,
            limit: 50,
          },
        },
        organizationId: organization.organization.external_id,
      });
    },
  );
  deviceOrganizationChannel.bind(
    `${constants.SOCKET_CHECKOUT_SUCCESSFUL}`,
    (e) => {
      if (organization.app_user_role === 'worker') return;
      const date = moment().format('YYYY-MM-DD');
      const from = moment(`${date} 00:00:00`, 'YYYY-MM-DD HH:mm:ss')
        .utc()
        .format();
      const to = moment(`${date} 23:59:59`, 'YYYY-MM-DD HH:mm:ss')
        .utc()
        .format();
      store.dispatch('appusers/refreshAttendance', {
        params: {
          params: {
            from,
            to,
            startPage: 0,
            limit: 50,
          },
        },
        organizationId: organization.organization.external_id,
      });
    },
  );
}
export default pusher;
